import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { completeLogin } from '../lib/auth'
import { Masthead } from '../components/Masthead'

/**
 * /auth/callback handler. Tessera redirects here with ?code=…&state=…
 * after the user authenticates. We exchange the code for a token and
 * route the user to the dashboard.
 */
export function AuthCallback() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const code = params.get('code')
    const state = params.get('state')
    if (!code || !state) {
      setError(t('auth.callback.error'))
      return
    }
    completeLogin(code, state)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : t('auth.callback.error'))
      })
  }, [params, navigate, t])

  return (
    <div className="wrap">
      <Masthead />
      <section className="auth-card">
        <div className="auth-card__inner">
          <div className="auth-card__label">{t('auth.callback.title')}</div>
          {!error ? (
            <p className="auth-card__hint">{t('auth.callback.exchanging')}</p>
          ) : (
            <p className="auth-card__error">{error}</p>
          )}
        </div>
      </section>
    </div>
  )
}
